// STYLES
import "normalize.css";
import "flexboxgrid";
import "swiper/dist/css/swiper.css";
import "sass/experiments.scss";
import "sass/utilities.scss";
import "sass/fonts.scss";
import "sass/header.scss";
import "sass/portfolio.scss";
import "sass/project.scss";
import "sass/footer.scss";
import "sass/404.scss";
import "sass/form.scss";
import "sass/btn.scss";
import "sass/contact.scss";
import "sass/home.scss";
import "sass/about.scss";
import "sass/modals.scss";
import "sass/globals.scss";
import "sass/blog.scss";
import "sass/custom.scss";
import "simplelightbox/dist/simple-lightbox.min.css";

import "./wave/entry.js";
import TweenLite from "gsap/TweenLite";
import ScrollMagic from "scrollmagic";
import "gsap.ScrollToPlugin";
import "ScrollMagic.animation.gsap";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import Vuelidate from "vuelidate";
import Inputmask from "inputmask";
import Headroom from "headroom.js";
import Swiper from "swiper/dist/js/swiper.esm.bundle";
import StickySidebar from "sticky-sidebar/src/sticky-sidebar";
import ContactForm from "./components/contact-form.vue";
import ResizeSensor from "css-element-queries/src/ResizeSensor";
import SimpleLightbox from "simplelightbox";

const isSafari =
    /Safari/.test(navigator.userAgent) &&
    /Apple Computer/.test(navigator.vendor);
const isNotXS = window.matchMedia("(min-width: 48em)").matches;

Vue.use(Vuelidate);
Vue.use(VueScrollTo, {
    duration: 1000,
    offset: isNotXS ? -70 : -60
});

/*Vue.directive("input-mask", {
    bind: function(el) {
        new Inputmask({"mask": "+{*}9{*}"}).mask(el);

        //new Inputmask({ mask: el.getAttribute('datamask'),"placeholder": ""  }).mask(el);
        //$(".phone-input").mask($(".phone-input").attr('datamask'),{placeholder: $(".phone-input").attr('placeholder')});
       // $("#phone-data").mask($("#phone-data").attr('data-inputmask'),{placeholder: $("#phone-data").attr('placeholder')});
    }
});*/

new Vue({
    el: "#app",
    components: {
        "contact-form": ContactForm,
    },
    data() {
        return {
            opacity: true,
            homeTitle: false,
            isBottomSidebar: false,
            headerXS: false,
            showModal: false,
        };
    },
    created() {
        if (isSafari) document.body.classList.add("safari");
        if (navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i))
            document.body.classList.add("mac");
        if (navigator.userAgent.match(/Android/i))
            document.body.classList.add("android");
    },
    mounted() {
        var lightbox = new SimpleLightbox(".gallery a", {
            /* options */
        });

        const controller = new ScrollMagic.Controller();

        document
            .querySelectorAll("[fb-iframe-plugin-query]")
            .forEach(function(el) {
                let parent = el.closest(".videoFbContent");

                el.setAttribute("data-width", parent.offsetWidth);
                el.setAttribute("data-height", parent.offsetHeight);
            });

        document.addEventListener("DOMContentLoaded", this.initLoader);

        new Headroom(this.$refs.header, {
            offset: 105
        }).init();

        if (
            this.$refs.sidebar &&
            window.matchMedia("(min-width: 1200px)").matches &&
            !isSafari
        ) {
            this.stickySidebar = new StickySidebar(this.$refs.sidebar, {
                containerSelector: ".js-sidebar-container",
                innerWrapperSelector: ".js-sidebar-inner",
                topSpacing: 100,
                bottomSpacing: 60,
                resizeSensor: true
            });
            this.$refs.sidebar.addEventListener(
                "affixed.container-bottom.stickySidebar",
                () => (this.isBottomSidebar = true)
            );
            this.$refs.sidebar.addEventListener(
                "affix.top.stickySidebar",
                () => (this.isBottomSidebar = false)
            );
        }

        /*if (window.matchMedia("(min-width: 1200px)").matches) {
    window.addEventListener("mousewheel", this.mouseWheel);
    window.addEventListener("DOMMouseScroll",  this.mouseWheel);
  }*/

        Array.prototype.forEach.call(
            document.querySelectorAll("[data-nav] a"),
            el => {
                el.addEventListener("mouseover", () =>
                    el.closest("[data-nav]").classList.add("opacity")
                );
                el.addEventListener("mouseleave", () =>
                    el.closest("[data-nav]").classList.remove("opacity")
                );
            }
        );

        new Swiper(this.$refs.slider, {
            loop: true,
            keyboardControl: true,
            slidesPerView: 5,
            followFinger: false,
            navigation: {
                nextEl: this.$refs.sliderNext,
                prevEl: this.$refs.sliderPrev
            },
            breakpoints: {
                928: {
                    slidesPerView: 3
                },
                696: {
                    slidesPerView: 2
                }
            }
        });

        new Swiper(this.$refs.sliderReviews, {
            loop: true,
            keyboardControl: true,
            slidesPerView: 3,
            followFinger: false,
            navigation: {
                nextEl: this.$refs.sliderReviewNext,
                prevEl: this.$refs.sliderReviewPrev
            },
            breakpoints: {
                928: {
                    slidesPerView: 2
                },
                696: {
                    slidesPerView: 1
                },
                490: {
                    slidesPerView: 1
                }
            }
        });

        new Swiper(this.$refs.sliderTeam, {
            keyboardControl: true,
            loop: true,
            navigation: {
                nextEl: this.$refs.sliderTeamNext,
                prevEl: this.$refs.sliderTeamPrev
            },
            spaceBetween: -60,
            breakpoints: {
                414: {
                    spaceBetween: -150
                },
                410: {
                    spaceBetween: -130
                },
                390: {
                    spaceBetween: -120
                },
                375: {
                    spaceBetween: -110
                },
                365: {
                    spaceBetween: -100
                },
                355: {
                    spaceBetween: -80
                },
                345: {
                    spaceBetween: -60
                },
                319: {
                    spaceBetween: 0
                }
            }
        });

        new Swiper(this.$refs.sliderXS, {
            keyboardControl: true,
            slidesPerView: 2,
            followFinger: false,
            //loop: true,
            navigation: {
                nextEl: this.$refs.sliderXSNext,
                prevEl: this.$refs.sliderXSPrev
            }
        });

        if (this.$refs.slider) {
            var tween1 = TweenLite.fromTo(
                ".scrollmagic-creativity .rectangle-2",
                5,
                {
                    transform: "translateY(100px)"
                },
                {
                    transform: "translateY(-100px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween1)
                .addTo(controller);

            var tween2 = TweenLite.fromTo(
                ".scrollmagic-creativity .rectangle-1",
                7.5,
                {
                    transform: "translateY(150px)"
                },
                {
                    transform: isNotXS
                        ? "translateY(-350px)"
                        : "translateY(-275px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween2)
                .addTo(controller);

            var tween3 = TweenLite.fromTo(
                ".scrollmagic-creativity .rectangle",
                10,
                {
                    transform: "translateY(200px)"
                },
                {
                    transform: "translateY(-100px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween3)
                .addTo(controller);

            var tween4 = TweenLite.fromTo(
                ".scrollmagic-creativity-top .creativity__descr",
                5,
                {
                    transform: isNotXS
                        ? "translateY(250px)"
                        : "translateY(200px)"
                },
                {
                    transform: isNotXS
                        ? "translateY(-150px)"
                        : "translateY(-100px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity-top",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween4)
                .addTo(controller);

            var tween5 = TweenLite.fromTo(
                ".scrollmagic-creativity-top .creativity__img",
                7.5,
                {
                    transform: isNotXS
                        ? "translateY(100px)"
                        : "translateY(50px)"
                },
                {
                    transform: "translateY(0)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity-top",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween5)
                .addTo(controller);

            var tween6 = TweenLite.fromTo(
                ".scrollmagic-creativity-top .rectangle",
                7,
                {
                    transform: isNotXS
                        ? "translateY(250px)"
                        : "translateY(300px)"
                },
                {
                    transform: isNotXS
                        ? "translateY(-250px)"
                        : "translateY(-350px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity-top",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween6)
                .addTo(controller);

            var tween7 = TweenLite.fromTo(
                ".scrollmagic-creativity-bottom .creativity__descr",
                5,
                {
                    transform: "translateY(100px)"
                },
                {
                    transform: "translateY(-150px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity-bottom",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween7)
                .addTo(controller);

            var tween8 = TweenLite.fromTo(
                ".scrollmagic-creativity-bottom .rectangle-b",
                10,
                {
                    transform: "translateY(150px)"
                },
                {
                    transform: "translateY(-200px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity-bottom",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween8)
                .addTo(controller);

            var tween9 = TweenLite.fromTo(
                ".scrollmagic-creativity-bottom .rectangle-3",
                20,
                {
                    transform: "translateY(200px)"
                },
                {
                    transform: "translateY(-250px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity-bottom",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween9)
                .addTo(controller);

            var tween10 = TweenLite.fromTo(
                ".scrollmagic-creativity-bottom .rectangle-2",
                25,
                {
                    transform: isNotXS
                        ? "translateY(200px)"
                        : "translateY(100px)"
                },
                {
                    transform: isNotXS
                        ? "translateY(-500px)"
                        : "translateY(-500px)"
                }
            );

            new ScrollMagic.Scene({
                triggerElement: ".scrollmagic-creativity-bottom",
                duration: "100%",
                triggerHook: "onEnter"
            })
                .setTween(tween10)
                .addTo(controller);
        }
    },

    beforeDestroy() {
        this.stickySidebar.destroy();
    },

    methods: {
        /*mouseWheel(event) {
  event.preventDefault();
  var scrollTime = 1.0,
  scrollDistance = 170,
  delta = event.wheelDelta / 120 || -event.detail / 3,
  scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop,
  finalScroll = scrollTop - parseInt(delta * scrollDistance);

  TweenLite.to(window, scrollTime, {
  scrollTo: {
  y: finalScroll,
  autoKill: true
},
ease: Power1.easeOut,
autoKill: true,
overwrite: 5
});
},*/

        initLoader() {
            this.opacity = false;

            setTimeout(() => {
                FB.XFBML.parse();

                this.homeTitle = true;
            }, 1000);
        },

        initSidebar() {},

        headerXSToggle() {
            this.headerXS = !this.headerXS;
            document.body.classList.toggle("modal-open");
        }
    }
});


Vue.component("modal", {
    template: "#modal-template",
    mounted:function(){

        $("#phone-data").mask($("#phone-data").attr('data-inputmask'),{placeholder: $("#phone-data").attr('placeholder')});
    }
});
$(document).ready(function() {
    $('.accordion-list .panel-heading').click(function() {
        $(this).next('.panel-collapse ').slideToggle();
        $(this).toggleClass('active');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js